<template lang="html">
	<div class="notif-bar row" :class="type" v-if="!autodestroy">
		<div class="sprt"></div>
		<div class="ctn-icon">
			<span class="icon-bandeau-alert"></span>
		</div>
		<div class="title">
			{{ title }}
		</div>
		<div class="text">
			{{ text }}
		</div>
		<div class="close" @click="autodestroy = true">
			<span class="icon-form-close"></span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'notif-bar',
	props: ['type', 'title', 'text'],
	data () {
		return {
			autodestroy: false
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/notif-bar.vue